import { Result } from "antd";
import React from "react";

export default function ListaVacia() {
  return <Result title="No exiten datos disponibles" />;
}
